<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md p-8 space-y-6">
      <h2 class="text-3xl font-bold text-center text-gray-800">Login</h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Email or Phone Number"
          v-model="loginIdentifier"
          required
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-300"
        />
        <input
          type="password"
          placeholder="Password"
          v-model="password"
          required
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-300"
        />
        <button
          type="submit"
          class="w-full bg-yellow-300 text-gray-900 font-bold py-2 rounded-md hover:bg-yellow-400 transition"
        >
          Login
        </button>
      </form>

      <div class="text-center space-y-2">
        <button @click="$emit('switch','signup')" class="text-pink-500 mx-10 hover:underline text-sm">
          Create an Account
        </button>
        <button @click="$emit('switch','forgot')" class="text-pink-500 hover:underline text-sm">
          Forgot Password?
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const emit = defineEmits(["success","error","switch"]);

const loginIdentifier = ref("");
const password = ref("");

const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

const submit = async () => {
  try {
    const res = await fetch(`${baseUrl}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: loginIdentifier.value, password: password.value }),
    });

    const data = await res.json();

    if (!res.ok) return emit("error", data.error || "Login failed!");

    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));

    emit("success","Login successful!");

    window.location.href = data.user.role === "admin"
      ? "/admin/dashboard"
      : "/";
  } catch {
    emit("error","Connection error");
  }
};
</script>
